import React, { useState, useEffect } from 'react';
import { Alert, Button, Space, Spin, Tag, Collapse } from 'antd';
import { ReloadOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const CeleryStatus = ({ callAction }) => {
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [restarting, setRestarting] = useState(false);
  const [collapsed, setCollapsed] = useState(true); // Start collapsed

  const fetchWorkers = async () => {
    setLoading(true);
    try {
      const res = await callAction('get_celery_workers', {});
      if (res?.success) {
        setWorkers(res.workers || []);
      }
    } catch (e) {
      console.error('Failed to fetch Celery workers:', e);
    } finally {
      setLoading(false);
    }
  };

  const handleKillAndRestart = async () => {
    setRestarting(true);
    try {
      const res = await callAction('kill_and_restart_celery', {});
      if (res?.success) {
        setWorkers(res.workers || []);
      }
    } catch (e) {
      console.error('Failed to restart Celery:', e);
    } finally {
      setRestarting(false);
    }
  };

  // Only poll when expanded
  useEffect(() => {
    if (!collapsed) {
      fetchWorkers();
      const interval = setInterval(fetchWorkers, 10000); // Refresh every 10 seconds
      return () => clearInterval(interval);
    }
  }, [collapsed]);

  const workerCount = workers.length;
  const type = workerCount === 0 ? 'error' : 'success';

  return (
    <Collapse 
      defaultActiveKey={[]} 
      onChange={(keys) => setCollapsed(keys.length === 0)}
      style={{ marginBottom: 16 }}
    >
      <Panel 
        header={
          <Space>
            <span style={{ fontWeight: 'bold' }}>Celery Workers:</span>
            <Tag color={workerCount === 0 ? 'red' : 'green'}>
              {workerCount} running
            </Tag>
          </Space>
        }
        key="1"
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <Space>
            <Button
              size="small"
              icon={<ReloadOutlined />}
              onClick={fetchWorkers}
              loading={loading}
            >
              Refresh
            </Button>
            <Button
              size="small"
              danger
              icon={<CloseCircleOutlined />}
              onClick={handleKillAndRestart}
              loading={restarting}
            >
              Kill & Restart
            </Button>
          </Space>
          {loading ? (
            <Spin size="small" />
          ) : workerCount > 0 ? (
            <div style={{ fontSize: 11 }}>
              {workers.map((w, i) => (
                <div key={i}>
                  PID {w.pid} | CPU: {w.cpu}% | MEM: {w.mem}% | {w.command}
                </div>
              ))}
            </div>
          ) : (
            <Alert 
              type="error" 
              message="No Celery workers running! Click 'Kill & Restart' to start them." 
              style={{ fontSize: 11 }}
            />
          )}
        </Space>
      </Panel>
    </Collapse>
  );
};

export default CeleryStatus;

